import styled from "styled-components";
import { VeryModal } from "../VeryModal";

const DivMain = styled(VeryModal)`
  .divBodyModal {
    .divSteps {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      gap: 8px 18px;
      margin-bottom: 26px;
      //border: 1px solid red;
      .btnStep {
        width: fit-content;
        gap: 6px;
        .btnIcon {
          border-radius: 100%;
          padding: 2px;
          color: #9ca3af;
          background-color: #f3f4f6;
          font-size: 13px;
        }
        .txtLabel {
          text-decoration: none;
          font-weight: 400;
          color: #6b7280;
        }
        .MuiTouchRipple-root {
          color: #1c1b1f62;
        }
        &.btnStepCompleted {
          .btnIcon {
            color: #ffffff;
            background-color: #16a34a;
          }
          .txtLabel {
            color: #15803d;
            font-weight: 600;
          }
        }
        &.btnStepSelected {
          .txtLabel {
            font-weight: 700;
            color: #111827;
          }
          .btnIcon {
            box-shadow: 0 0 0 2px #3b82f6;
          }
        }
      }
    }
  }
  .divButtons {
    .btnMain {
      max-width: 420px;
    }
  }
`;

export default {
  DivMain,
};
